import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import { CardComponent } from './card/card.component';
import {ParentRemoveDirective} from './elements/parent-remove.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {AnimatorModule} from 'css-animator';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from "ngx-spinner";
import {DataFilterPipe} from './elements/data-filter.pipe';
import {DataTableModule} from 'angular2-datatable';
import {AgmCoreModule} from '@agm/core';
import {TodoService} from './todo/todo.service';
import {ClickOutsideModule} from 'ng-click-outside';
import {SpinnerComponent} from './spinner/spinner.component';
import {PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {NotificationsService} from 'angular2-notifications';
import {TreeviewModule} from 'ngx-treeview';
import {SafePipe} from './elements/safe.pipe';
import { DateAgoPipe } from './elements/data-ago.pipes';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      SimpleNotificationsModule.forRoot(),
      AnimatorModule,
      NgxDatatableModule,
      DataTableModule,
      AgmCoreModule.forRoot(),
      ClickOutsideModule,
      PerfectScrollbarModule,
      TreeviewModule.forRoot(),
      NgxSpinnerModule
  ],
  declarations: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      CardComponent,
      SpinnerComponent,
      ModalAnimationComponent,
      ModalBasicComponent,
      DataFilterPipe,
      SafePipe,
      DateAgoPipe
  ],
  exports: [
      AccordionAnchorDirective,
      AccordionLinkDirective,
      AccordionDirective,
      ToggleFullscreenDirective,
      CardRefreshDirective,
      CardToggleDirective,
      ParentRemoveDirective,
      NgbModule,
      CardComponent,
      SpinnerComponent,
      FormsModule,
      ReactiveFormsModule,
      ModalBasicComponent,
      ModalAnimationComponent,
      SimpleNotificationsModule,
      AnimatorModule,
      NgxDatatableModule,
      DataTableModule,
      DataFilterPipe,
      AgmCoreModule,
      ClickOutsideModule,
      PerfectScrollbarModule,
      TreeviewModule,
      DateAgoPipe,
      NgxSpinnerModule
  ],
  providers: [
      MenuItems,
      TodoService,
      NotificationsService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class SharedModule { }
